// extracted by mini-css-extract-plugin
module.exports = {"datatoken":"index-module--datatoken--2qGoa"};